import {STATIC_PERMISSIONS} from './deviceViewStaticPermissions'
import {TAB_PERMISSIONS} from './deviceViewTabsPermissions'
import {PROFILE_PERMISSIONS} from './deviceViewProfilePermissions'

export const PERMISSIONS = {
  STATIC: STATIC_PERMISSIONS,
  TAB: TAB_PERMISSIONS,
  PROFILE: PROFILE_PERMISSIONS
}
